import {
    OverlappingAvatars,
    SingleAvatar,
} from '@/components/users/UserAvatars';
import { FlexProps } from '@chakra-ui/react';
import { PAGE_MODE_MINE_COLOR } from '@common/react/pageMode';
import { isSingleplayer, useCurrentUser } from '@common/react/user';
import { useGoalDetailContext } from './GoalDetailContext';
import GoalDetailHeaderLayout from './GoalDetailHeaderLayout';

export default function GoalDetailHeader(props: FlexProps) {
    const currentUser = useCurrentUser();
    const { goalLoading, goal } = useGoalDetailContext();
    const isPrivate = goal?.shareStatus === 'PRIVATE';
    const bg =
        isPrivate && !isSingleplayer(currentUser)
            ? PAGE_MODE_MINE_COLOR
            : 'gray.50';

    const avatarStyles = {
        size: 'sm',
        bg,
    };

    return (
        <>
            <GoalDetailHeaderLayout {...props}>
                {goalLoading ? (
                    <></>
                ) : isPrivate ? (
                    <SingleAvatar
                        withLock={!isSingleplayer(currentUser)}
                        {...avatarStyles}
                    />
                ) : (
                    <OverlappingAvatars {...avatarStyles} />
                )}
            </GoalDetailHeaderLayout>
        </>
    );
}
